import { PixelRatio, Dimensions } from 'react-native';
const window = Dimensions.get('window');
export const screen = {
    width: window.width,
    height: window.height,
    dpd: PixelRatio.get()
};
/**
 * borderWidth、radius、1px 分割线不要调用该系数
 * @param size
 * @param scaleEnable
 */
export function scale(size, scaleEnable = true) {
    // 是否需要缩放
    if (!scaleEnable) {
        return size;
    }
    // 计算值
    let computeSize;
    if (screen.width <= 360) {
        computeSize = 0.96 * size;
    }
    else if (screen.width <= 375) {
        computeSize = size;
    }
    else {
        computeSize = 1.1 * size;
    }
    return Math.round(computeSize);
}
